import { UserPageDataRoleItem } from '@maxpreps/apiserviceclients/apiModels';
import TeamLevel from '@maxpreps/shared/constants/teamLevel';
import useTeamContext, {
  ITeamContext
} from '@maxpreps/shared/contexts/TeamContext';
import { hasPermission } from '@maxpreps/shared/functions/utils/userUtils';
import { useUserRoles } from '@maxpreps/shared/redux/user/userHooks';
import buildTeamAuthorizationObject from './buildTeamAuthorizationObject';

export const isUserATeamAdmin = (
  teamContext: ITeamContext,
  roles: UserPageDataRoleItem[],
  teamLevel?: TeamLevel
): boolean => {
  const teamAuthorizationObject = buildTeamAuthorizationObject(
    undefined,
    { teamContext },
    teamLevel
  );
  return !!hasPermission(teamAuthorizationObject, roles);
};

const useIsUserATeamAdmin = (teamLevel?: TeamLevel) => {
  const roles = useUserRoles();
  const teamContext = useTeamContext();

  return isUserATeamAdmin(teamContext, roles, teamLevel);
};

export default useIsUserATeamAdmin;
